<template>
  <div id="contenedor-agregar-catalogo-contrato-evento">
    <v-form v-model="formularioValido" ref="registrarCatalogoContratoEvento">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar nuevo Contrato Evento
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre del Contrato Evento"
            v-model="contratoEvento.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
          <custom-select
            label="Tipo de Contrato Evento"
            v-model="contratoEvento.tipo"
            :items="['Tipo 1', 'Tipo 2', 'Tipo 3']"
            :rules="[mixReglas.requerido]"
            required
          />
          <custom-text-field
            label="Orden"
            v-model="contratoEvento.orden"
            type="number"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardar"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import mixContratosEventos from './mixContratosEventos';

export default {
  name: 'AgregarCatalogoContratoEvento',
  mixins: [mixContratosEventos],
  components: {
    CustomButton,
    CustomTextField,
    CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      contratoEvento: {
        nombre: '',
        tipo: '',
        orden: 0,
      },
    };
  },
};
</script>

<style lang="scss">

</style>
